"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var date_fns_1 = require("date-fns");
var react_1 = require("react");
var format = function (number) {
    return number >= 0 && "".concat(number).length === 1 ? "0".concat(number) : number;
};
var useTimer = function (endDateString) {
    var endDate = endDateString && new Date(endDateString);
    var currentDate = new Date();
    var isNextSpinDatePast = currentDate > endDate;
    var daysLeft = (0, date_fns_1.differenceInDays)(endDate, currentDate);
    currentDate = (0, date_fns_1.addDays)(currentDate, daysLeft);
    var hoursLeft = format((0, date_fns_1.differenceInHours)(endDate, currentDate));
    currentDate = (0, date_fns_1.addHours)(currentDate, hoursLeft);
    var minutesLeft = format((0, date_fns_1.differenceInMinutes)(endDate, currentDate));
    currentDate = (0, date_fns_1.addMinutes)(currentDate, minutesLeft);
    var secondsLeft = format((0, date_fns_1.differenceInSeconds)(endDate, currentDate));
    var _a = (0, react_1.useState)({
        days: daysLeft,
        hours: hoursLeft,
        minutes: minutesLeft,
        seconds: secondsLeft,
    }), time = _a[0], setTime = _a[1];
    (0, react_1.useEffect)(function () {
        var timer = setTimeout(function () {
            setTime({
                days: Number.isNaN(daysLeft) ? 0 : daysLeft,
                hours: Number.isNaN(hoursLeft) ? 0 : hoursLeft,
                minutes: Number.isNaN(minutesLeft) ? 0 : minutesLeft,
                seconds: Number.isNaN(secondsLeft) ? 0 : secondsLeft,
            });
        }, 1000);
        return function () { return clearTimeout(timer); };
    });
    return {
        time: time,
        hasTime: !isNextSpinDatePast &&
            (daysLeft > 0 || hoursLeft > 0 || minutesLeft || secondsLeft > 0),
    };
};
exports.default = useTimer;
